import Icon from '../components/Icon.vue'

Icon.register({"step-forward":{"width":448,"height":512,"paths":[{"d":"M384 44V468C384 474.6 378.6 480 372 480H324C317.4 480 312 474.6 312 468V291.6L116.5 472.6C95.9 489.7 64 475.4 64 448V64C64 36.6 95.9 22.3 116.5 39.4L312 219.3V44C312 37.4 317.4 32 324 32H372C378.6 32 384 37.4 384 44z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/step-forward.js
// module id = IqG6
// module chunks = 0